import sanityClient from "../../sanityClient";

export const fetchSEOData = async (slug) => {
  const query = `*[_type == "seo" && url == $slug][0]`;
  const params = { slug };
  return await sanityClient.fetch(query, params);
};